/** @jsx jsx */
import { cssMap, jsx } from '@atlaskit/css';
import HighlightText from '@atlassian/jira-software-highlight-text/src/ui/index.tsx';

type Props = {
	highlight?: string[];
	text: string;
};

export const CardSummary = ({ highlight, text }: Props) => {
	return (
		<span css={styles.root}>
			<HighlightText highlight={highlight ?? null} text={text} />
		</span>
	);
};

const styles = cssMap({
	root: {
		overflowWrap: 'break-word',
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
});
